import Vue from "vue";
import store from "@/store";

import { syncGetToken } from "@/utils/auth"; // getToken from cookie
import Router from "vue-router";
// import signIn from "./login";
// import Config from "./config";

Vue.use(Router);

export const routers = [
  {
    path: "",
    redirect: "/home",
    meta: {
      title: "MIS2.0"
    },
    component: (resolve) => require(["./views/home.vue"], resolve),
    children: [
      {
        path: "/home",
        name: "home",
        component: (resolve) => require(["./views/project/index.vue"], resolve)
      },
      {
        path: "/home/detail",
        name: "detail",
        component: (resolve) => require(["./views/project/detail.vue"], resolve)
      },

      // 项目信息-验收管理
      {
        path: "/acceptance",
        name: "acceptance",
        component: (resolve) =>
          require(["./views/project/acceptance.vue"], resolve)
      },
      // 项目信息-外采合同
      {
        path: "/external",
        name: "external",
        component: (resolve) =>
          require(["./views/project/external-contracts.vue"], resolve)
      },
      // 项目信息-成本管理
      {
        path: "/cost",
        name: "cost",
        component: (resolve) =>
          require(["./views/project/labor-cost.vue"], resolve)
      },
      {
        path: "/lifecycle",
        name: "lifecycle",
        component: (resolve) =>
          require(["./views/lifecycle/index.vue"], resolve)
      },
      {
        path: "/sales",
        name: "sales",
        component: (resolve) => require(["./views/sales/index.vue"], resolve)
      },
      {
        path: "/market",
        name: "market",
        component: (resolve) => require(["./views/market/index.vue"], resolve)
      },
      {
        path: "/version",
        name: "version",
        component: (resolve) => require(["./views/version/index.vue"], resolve)
      }
    ]
  },
  {
    path: "*",
    component: (resolve) => require(["./views/404.vue"], resolve)
  }
];

export const router = new Router({
  base: "/",
  mode: "history",
  routes: routers,
  linkActiveClass: "active"
});

const whiteList = ["/login", "/auth-redirect"]; // no redirect whitelist
router.beforeEach((to, from, next) => {
  store.commit("SET_VISIBLE", String(to.query.edit) === "true");

  // NProgress.start() // start progress bar
  if (whiteList.indexOf(to.path) !== -1) {
    // 在免登录白名单，直接进入
    next();
  } else if (store.getters.noAsyncGetToken) {
    store.commit("SET_NOASYNCGETTOKEN", false);
    next();
  } else {
    syncGetToken("FN_REFTOKEN")
      .then((res) => {
        let { token } = res;

        if (token) {
          if (to.path === "/login") {
            next({
              path: "/"
            });
            return;
          } else if (to.path === "/404") {
            next();
            return;
          }
          if (store.getters.roles.length === 0) {
            // 判断当前用户是否已拉取完user_info信息
            store
              .dispatch("GetUserInfo")
              .then((data) => {
                // 拉取user_info
                // console.log(store);
                // store
                //   .dispatch("GenerateRoutes", {
                //     templates: store.getters.templates,
                //     routers: data,
                //     name: Config.name,
                //     indexPath: Config.indexPath
                //   })
                //   .then(() => {
                //     // 根据roles权限生成可访问的路由表
                //     router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
                //     next({
                //       ...to,
                //       replace: true
                //     }); // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                //   });
                store.dispatch("WebStockInit");
              })
              .catch((err) => {
                console.log(err);
                next({
                  path: "/404"
                });
              });
          } else {
            next();
          }
        } else {
          next({
            path: "/login"
            // query: { redirect: to.fullPath }
          });
        }
      })
      .catch((err) => {
        console.error(err);
        next();
      });
  }

  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

router.afterEach(() => {
  // NProgress.done() // finish progress bar
});
